var _defs, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditSalaryComponents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 29.225,
    cy: 14.342,
    r: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M19.174 23.337L32.08 27.09c-2.059 7.08-9.579 11.212-16.659 9.153S4.209 26.664 6.268 19.584a13.455 13.455 0 019.703-9.301l3.203 13.053z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M24.106 19.184L20.903 6.131c4.006-.983 8.068-.024 11.177 2.265a13.585 13.585 0 012.075 1.887 13.293 13.293 0 013.004 5.698 13.456 13.456 0 01-.148 6.956l-12.906-3.753z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSalaryComponents);
export default __webpack_public_path__ + "static/media/editSalaryComponents.8a9797c5569d0b33cbe538b44214b6c6.svg";
export { ForwardRef as ReactComponent };